import {
  isLabDnaStepFieldEnabledForServices,
  labDnaStepMaxConcentrationWithoutDilutionNgUl,
  normalizeNullableNumber,
  type LabWorkbookService,
  type LabDnaStepRow,
} from '@resistapp/common/lab-dna-step';

export function shouldPreserveLocalWorkbookServices(
  requestServicesVersion: number,
  currentServicesVersion: number,
  servicesSaving: boolean,
): boolean {
  return servicesSaving || requestServicesVersion < currentServicesVersion;
}

export function shouldHighlightDnaDilutionDesiredFinalVolumeCell(
  row: Pick<LabDnaStepRow, 'qaConcentrationNgUl'> | null | undefined,
  services: readonly LabWorkbookService[] | null | undefined,
): boolean {
  const measuredConcentration = normalizeNullableNumber(row?.qaConcentrationNgUl);
  return (
    measuredConcentration != null &&
    measuredConcentration > labDnaStepMaxConcentrationWithoutDilutionNgUl &&
    isLabDnaStepFieldEnabledForServices('dilutionDesiredFinalVolumeUl', services)
  );
}
